import { IHttpResponse } from '@gr/shared/models';
import useAxios, { UseAxiosResult } from 'axios-hooks';

interface TenantData {
  reEngagementEnabled: boolean;
}

export default function useTenant(): UseAxiosResult<IHttpResponse<TenantData>> {
  return useAxios<IHttpResponse<TenantData>>({
    url: '/optins/tenants/data',
    method: 'GET'
  });
} 